import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactTooltip from 'react-tooltip';
import FilterIcon from '../../../../assets/img/oecd_dac_codes.svg';
import InfoBlue from '../../../../assets/img/info-blue.svg';
// import NewTag from '../../../../assets/img/new_tag.svg';

const PrimaryDacCode = ( props ) => {
  const {
    classes, filters, isLoading, checkedListAll, handlePrimaryDacCodeFiltersTest,
  } = props;

  const [open, setOpen] = useState( !!( checkedListAll && checkedListAll.length > 0 ) );

  const handleClick = () => {
    setOpen( !open );
  };

  const renderPrimaryDacCode = ( primaryDacCodes ) => primaryDacCodes.map( ( info ) => {
    let checked = false;
    let list = '';
    if ( checkedListAll && checkedListAll.indexOf( info.key ) > -1 ) {
      checked = true;
    }
    if ( info.key !== '' ) {
      list = (
        <ListItem button className={classes.nested} key={info.key}>
          <ListItemText className={classes.filterItem}>
            <FormControlLabel
              className={classes.checkBox}
              control={(
                <Checkbox
                  value={info.key}
                  classes={{
                    root: classes.checkBox,
                    checked: classes.checked,
                  }}
                  checked={checked}
                  onClick={!isLoading && handlePrimaryDacCodeFiltersTest}
                  disabled={isLoading}
                  disableRipple
                />
                    )}
              label={`${info.key} (${info.doc_count})`}
            />
          </ListItemText>
        </ListItem>
      );
    }
    return list;
  } );

  return (
    <List className={classes.filterMenu}>
      <ListItem button onClick={handleClick} className={classes.filterHead}>
        <ListItemText>
          <div className={classes.SVG__Filter}>
            <img src={FilterIcon} alt="" />
            &nbsp;
            OECD DAC CODES
            <img data-for="primaryDacCodeInfo" data-event="click focus mouseover" data-tip className={classes.infoIcon} src={InfoBlue} alt="" />
            <ReactTooltip id="primaryDacCodeInfo" className={classNames( classes.reactTooltip, classes.reactTooltipClickableLink )} globalEventOff="mouseover" place="right" type="light" effect="solid">
              <span>
                This is the primary code for
                {' '}
                <a href="https://www.oecd.org/development/financing-sustainable-development/development-finance-standards/purposecodessectorclassification.htm" rel="noopener noreferrer" target="_blank">OECD DAC sector classification</a>
                . Secondary, CRS, Voluntary codes are available using Advanced search.
              </span>
            </ReactTooltip>
          </div>
        </ListItemText>
        {
          open ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.filterMenuBlock}>
        <div className={classes.maxHeightScroll}>
          <Scrollbars autoHeight>
            <List component="div" disablePadding>
              {
            filters
              ? (
                renderPrimaryDacCode( filters )
              )
              : ( <span className={classes.noFiltersFound}>No filters for OECD DAC Codes</span> )
          }
            </List>
          </Scrollbars>
        </div>
      </Collapse>
    </List>
  );
};

PrimaryDacCode.defaultProps = {
  filters: null,
  isLoading: false,
  checkedListAll: null,
};

PrimaryDacCode.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.arrayOf( PropTypes.object ),
  handlePrimaryDacCodeFiltersTest: PropTypes.func.isRequired,
  checkedListAll: PropTypes.arrayOf( PropTypes.string ),
};

export default PrimaryDacCode;
